'use client';
import { useState } from 'react';
 import Icon from'@/components/ui/AppIcon';

const WhatsAppButton = () => {
  const [isHovered, setIsHovered] = useState(false)
  const whatsappNumber = '18634409462'
  const message = encodeURIComponent('Hi! I\'m interested in learning more about your container solutions.')

  return (
    <a
      href={`https://wa.me/${whatsappNumber}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="fixed bottom-8 right-8 z-50 flex items-center gap-3 bg-success text-success-foreground font-semibold rounded-full px-6 py-4 shadow-2xl hover:scale-105 transition-all animate-pulse-subtle"
      aria-label="Contact us on WhatsApp"
    >
      <Icon name="ChatBubbleLeftRightIcon" size={24} />
      {isHovered && (
        <span className="animate-slide-in-right">
          Chat on WhatsApp
        </span>
      )}
    </a>
  )
}

export default WhatsAppButton